import { ICategory } from "api/types/_category";
import { Option } from "api/types/_public";
import { IKeywordPublishedStatistic } from "api/types/_statistic";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownOption from "components/Common/DropdownOption";
import InputsRange from "components/Common/InputsRange";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableContainer from "components/Common/TableContainer";
import { useRole } from "components/Hooks/UserHooks";
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { TYPE_LEVEL_KEYWORD_OPTIONS } from "helpers/constans";
import { formatNumberWithCommas } from "helpers/format";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { getAllCategory, keywordPublishedStatistics as onGetKeywordPublishedStatistics, setKeywordGoldenMulti } from "../../../store/thunks";
import TrackingNewsList from "pages/News/TrackingNews";
import { ROUTES } from "routes/allRoutes";
import NestingFilter from "pages/News/Components/NestingFilter";


const SORT_BY_DEFAULT = 'click';
const ORDER_BY_DEFAULT = 'DESC';

registerLocale('en', en);
registerLocale('ko', ko);

const KeywordStatistic = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const TYPE_LEVEL_KEYWORD_OPTIONS_LANG = TYPE_LEVEL_KEYWORD_OPTIONS?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const AFFILIATE_MEDIA_OPTIONS_LANG = [{ label: 'Included2', value: '1' }, { label: 'Not Included2', value: '0' }]?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 100),
        sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
        order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
        category_id: withDefault(StringParam, ''),
        keyword: withDefault(StringParam, ''),
        is_golden: withDefault(StringParam, ''),
        is_affiliate_rank: withDefault(StringParam, ''),
        impression_start: withDefault(StringParam, ''),
        impression_end: withDefault(StringParam, ''),
        click_start: withDefault(StringParam, ''),
        click_end: withDefault(StringParam, ''),
        ctr_start: withDefault(StringParam, ''),
        ctr_end: withDefault(StringParam, ''),
        approved_article_count_start: withDefault(StringParam, ''),
        approved_article_count_end: withDefault(StringParam, ''),
        daily_search_volume_start: withDefault(StringParam, ''),
        daily_search_volume_end: withDefault(StringParam, ''),
        article_rank_start: withDefault(StringParam, ''),
        article_rank_end: withDefault(StringParam, ''),
        survival_period_start: withDefault(StringParam, ''),
        survival_period_end: withDefault(StringParam, ''),
        news_section_rank_start: withDefault(StringParam, ''),
        news_section_rank_end: withDefault(StringParam, ''),
        affiliate_rank_start: withDefault(StringParam, ''),
        affiliate_rank_end: withDefault(StringParam, ''),
        date_start: withDefault(StringParam, `${moment().subtract(7, 'days').format("Y-MM-DD")}`),
        date_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        published_at_start: withDefault(StringParam, `${moment().subtract(7, 'days').format("Y-MM-DD")}`),
        published_at_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Statistic;

    const StatisticProperties = createSelector(
        selectLayoutState,
        (state) => ({
            keywordPublished: state.keywordPublished,
            isKeywordPublishedSuccess: state.isKeywordPublishedSuccess,
            isKeywordPublishedLoading: state.isKeywordPublishedLoading,
            error: state.error,
        })
    );

    const { keywordPublished, isKeywordPublishedLoading } = useSelector(StatisticProperties);

    const [optionsSelected, setOptionsSelected] = useState<any>([]);

    const [listCategory, setListCategory] = useState<ICategory[]>([]);

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<IKeywordPublishedStatistic | null>(null);

    const [isCallAllOptionLoading, setIsCallAllOptionLoading] = useState<boolean>(true);

    const [typeKeywordSearch, setTypeKeywordSearch] = useState<Option | null>(TYPE_LEVEL_KEYWORD_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.is_golden)) || null);


    const [affiliateMediaSearch, setAffiliateMediaSearch] = useState<Option | null>(AFFILIATE_MEDIA_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.is_affiliate_rank)) || null);


    const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

    const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.date_start ? moment(query?.date_start, 'Y-MM-DD').toDate() : null, query?.date_end ? moment(query?.date_end || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateRangeSearch;

    const [datePublishedRangeSearch, setDatePublishedRangeSearch] = useState<any[]>([query?.published_at_start ? moment(query?.published_at_start, 'Y-MM-DD').toDate() : null, query?.published_at_end ? moment(query?.published_at_end || '', 'Y-MM-DD').toDate() : null]);
    const [startDatePublished, endDatePublished] = datePublishedRangeSearch;

    const [startApprovedArticleSearch, setStartApprovedArticleSearch] = useState<string>(query?.approved_article_count_start || "");
    const [endApprovedArticleSearch, setEndApprovedArticleSearch] = useState<string>(query?.approved_article_count_end || "");

    const [startDailySearchVolumeSearch, setStartDailySearchVolumeSearch] = useState<string>(query?.daily_search_volume_start || "");
    const [endDailySearchVolumeSearch, setEndDailySearchVolumeSearch] = useState<string>(query?.daily_search_volume_end || "");

    const [startAvgArticleRankSearch, setStartAvgArticleRankSearch] = useState<string>(query?.article_rank_start || "");
    const [endAvgArticleRankSearch, setEndAvgArticleRankSearch] = useState<string>(query?.article_rank_end || "");

    const [startAvgSurvivalPeriodSearch, setStartAvgSurvivalPeriodSearch] = useState<string>(query?.survival_period_start || "");
    const [endAvgSurvivalPeriodSearch, setEndAvgSurvivalPeriodSearch] = useState<string>(query?.survival_period_end || "");

    const [startImpressionSearch, setStartImpressionSearch] = useState<string>(query?.impression_start || "");
    const [endImpressionSearch, setEndImpressionSearch] = useState<string>(query?.impression_end || "");

    const [startClickSearch, setStartClickSearch] = useState<string>(query?.click_start || "");
    const [endClickSearch, setEndClickSearch] = useState<string>(query?.click_end || "");

    const [startCtrSearch, setStartCtrSearch] = useState<string>(query?.ctr_start || "");
    const [endCtrSearch, setEndCtrSearch] = useState<string>(query?.ctr_end || "");

    const [startNewsSectionSearch, setStartNewsSectionSearch] = useState<string>(query?.news_section_rank_start || "");
    const [endNewsSectionSearch, setEndNewsSectionSearch] = useState<string>(query?.news_section_rank_end || "");

    const [startAffiliateRankSearch, setStartAffiliateRankSearch] = useState<string>(query?.affiliate_rank_start || "");
    const [endAffiliateRankSearch, setEndAffiliateRankSearch] = useState<string>(query?.affiliate_rank_end || "");


    const [isOpenNewsTracking, setIsOpenNewsTracking] = useState<boolean>(false);

    useEffect(() => {
        dispatch(onGetKeywordPublishedStatistics(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        if (isKeywordPublishedLoading) {
            return;
        }
        setQuery({
            ...query,
            page: 1,
            keyword: keywordSearch || '',

            is_golden: typeKeywordSearch?.value,

            is_affiliate_rank: affiliateMediaSearch?.value,

            approved_article_count_start: startApprovedArticleSearch || '',
            approved_article_count_end: endApprovedArticleSearch || '',

            daily_search_volume_start: startDailySearchVolumeSearch || '',
            daily_search_volume_end: endDailySearchVolumeSearch || '',

            article_rank_start: startAvgArticleRankSearch || '',
            article_rank_end: endAvgArticleRankSearch || '',

            survival_period_start: startAvgSurvivalPeriodSearch || '',
            survival_period_end: endAvgSurvivalPeriodSearch || '',

            impression_start: startImpressionSearch || '',
            impression_end: endImpressionSearch || '',

            click_start: startClickSearch || '',
            click_end: endClickSearch || '',

            ctr_start: startCtrSearch || '',
            ctr_end: endCtrSearch || '',

            news_section_rank_start: startNewsSectionSearch || '',
            news_section_rank_end: endNewsSectionSearch || '',

            affiliate_rank_start: startAffiliateRankSearch || '',
            affiliate_rank_end: endAffiliateRankSearch || '',


            date_start: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            date_end: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',

            published_at_start: startDatePublished ? moment(new Date(startDatePublished)).format("Y-MM-DD") : '',
            published_at_end: endDatePublished ? moment(new Date(endDatePublished)).format("Y-MM-DD") : '',

            time_request: + new Date()
        });
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            category_id: '',
            keyword: '',
            is_golden: '',
            is_affiliate_rank: '',
            approved_article_count_start: '',
            approved_article_count_end: '',
            daily_search_volume_start: '',
            daily_search_volume_end: '',
            article_rank_start: '',
            article_rank_end: '',
            survival_period_start: '',
            survival_period_end: '',
            impression_start: '',
            impression_end: '',
            click_start: '',
            click_end: '',
            ctr_start: '',
            ctr_end: '',
            news_section_rank_start: '',
            news_section_rank_end: '',
            affiliate_rank_start: '',
            affiliate_rank_end: '',

            date_start: `${moment().subtract(7, 'days').format("Y-MM-DD")}`,
            date_end: `${moment().format("Y-MM-DD")}`,
            published_at_start: `${moment().subtract(7, 'days').format("Y-MM-DD")}`,
            published_at_end: `${moment().format("Y-MM-DD")}`,
            sort_by: SORT_BY_DEFAULT,
            order_by: ORDER_BY_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setKeywordSearch('');
        setTypeKeywordSearch({ label: t('All'), value: '' });
        setAffiliateMediaSearch(null)
        setStartApprovedArticleSearch(queryNew?.approved_article_count_start);
        setEndApprovedArticleSearch(queryNew?.approved_article_count_end);
        setStartDailySearchVolumeSearch(queryNew?.daily_search_volume_start);
        setEndDailySearchVolumeSearch(queryNew?.daily_search_volume_end);
        setStartAvgArticleRankSearch(queryNew?.article_rank_start);
        setEndAvgArticleRankSearch(queryNew?.article_rank_end);
        setStartAvgSurvivalPeriodSearch(queryNew?.survival_period_start);
        setEndAvgSurvivalPeriodSearch(queryNew?.survival_period_end);
        setStartImpressionSearch(queryNew?.impression_start);
        setEndImpressionSearch(queryNew?.impression_end);
        setStartClickSearch(queryNew?.click_start);
        setEndClickSearch(queryNew?.click_end);
        setStartCtrSearch(queryNew?.ctr_start);
        setEndCtrSearch(queryNew?.ctr_end);
        setStartNewsSectionSearch(queryNew?.news_section_rank_start);
        setEndNewsSectionSearch(queryNew?.news_section_rank_end);
        setStartAffiliateRankSearch(queryNew?.affiliate_rank_start);
        setEndAffiliateRankSearch(queryNew?.affiliate_rank_end);
        setDateRangeSearch([moment(queryNew?.date_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.date_end || "", 'Y-MM-DD').toDate()]);
        setDatePublishedRangeSearch([moment(queryNew?.published_at_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.published_at_end || "", 'Y-MM-DD').toDate()]);
    };


    const triggerRefresh = () => {
        // onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        });
    }

    const renderUrlNewsTracking = (_params_url: { _keyword: string, _published_start: string, _published_end: string }) => {
        const _url: string = `${ROUTES.ARTICLE_TRACKING}?keyword=${_params_url?._keyword}&published_start=${_params_url?._published_start}&published_end=${_params_url?._published_end}`;
        return _url;
    }

    const onOpenPageTrackingNewsClick = (_keyword: string = '') => {
        if (!_keyword) {
            return;
        }
        setQuery((prev: any) => ({ ...prev, keyword: _keyword, published_start: prev?.published_at_start, published_end: prev?.published_at_end }));
        setIsOpenNewsTracking((_prev) => true);
    };
    const onClosePageTrackingNewsClick = () => {
        setIsOpenNewsTracking((_prev) => false);
    };

    // Begin::Set Golden Keyword
    const handleConfirmSetGoldenKeyword = (item: IKeywordPublishedStatistic | null) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionSetGoldenKeyword = async () => {
        if (!initialValuesDefault?.id && !countRowSelected) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const ids = initialValuesDefault?.id ? [initialValuesDefault?.id] : (optionsSelected || []).flat()?.map((item: any) => item?.value);
            const response: any = await setKeywordGoldenMulti({
                ids: ids,
                is_golden: 1,
            });
            if (response?.code === 200) {
                triggerRefresh();
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                if (!initialValuesDefault?.id) {
                    setOptionsSelected((prev: any) => []);
                }
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Set Golden Keyword

    // Begin:: handle select table 
    const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
        // if (!!isFirstLoadingPageRef.current) {
        //   return;
        // }
        const index = String(valueIndex);
        if (valueCheck?.value === 'ALL') {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (e.target.checked) {
                    if (prevClone[index] === undefined) {
                        prevClone[index] = [];
                    }
                    prevClone[index] = (keywordPublished?.list || [])?.map((item: any) => ({ value: item?.keyword_id, label: item?.keyword_id }));
                    return prevClone;
                } else {
                    prevClone[index] = [];
                    return prevClone;
                }
            });
            return;
        }
        if (!e.target.checked) {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
                return prevClone;
            });
        } else {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = ([...prevClone[index], valueCheck]);
                return prevClone;
            });
        }
    };

    const isChecked = (valueCheck: Option) => {
        const index = String(query.page);
        return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
    };

    const isCheckedAll = (valueIndex: string) => {
        const valueIndexString = String(valueIndex);
        return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === keywordPublished?.list?.length);
    };

    const countRowSelected = useMemo(() => {
        return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
            return Number(total + (value || [])?.length);
        }, 0)
    }, [optionsSelected]);

    // End:: handle select table 

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('Key'),
                accessor: "",
                filterable: true,
                sortable: false,
                thClass: 'text-start align-middle',
                thWidth: 50,
                thComponent: () => (<>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
                        <label className="form-check-label" htmlFor={`cell-check-all`}></label>
                    </div>
                </>
                ),
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <>
                            <div className={`form-check`}>
                                <input className="form-check-input" type="checkbox" name="table" checked={isChecked({ value: cell?.row?.original?.keyword_id, label: cell?.row?.original?.keyword_id })} value={cell?.row?.original?.keyword_id ?? ''} onChange={(e) => handleCheck(({ value: cell?.row?.original?.keyword_id, label: cell?.row?.original?.keyword_id }), query?.page, e)} id={`cell-check-${cell?.row?.original?.keyword_id ?? ''}`} />
                                <label className="form-check-label" htmlFor={`cell-check-${cell?.row?.original?.keyword_id ?? ''}`}></label>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="d-flex justify-content-between align-items-center cursor-pointer ">
                            <Link className='text-normal nav-link  flex-grow-1 hover-underline' to={renderUrlNewsTracking({ _keyword: cell?.value, _published_start: query?.published_at_start, _published_end: query?.published_at_end })} target="_blank" style={{ minWidth: '100px' }}>
                                {cell?.value}
                            </Link>
                            {!!item?.is_golden && <i className="bx bx-medal text-warning fs-18" />}
                        </div>
                    )
                },
            },
            {
                Header: t('Approved Articles'),
                accessor: "approved_article_count",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: i18n?.language === 'en' ? 180 : 120,
                description: t('The number of approved articles within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '160px' : '100px' }}>{formatNumberWithCommas(cell?.value)}</div>
                        </>
                    )
                },
            },
            {
                Header: t('Daily Search Volume'),
                accessor: "daily_search_volume",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 200 : 140,
                thClass: 'align-middle text-end',
                description: t('The average daily search volume within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '180px' : '120px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
                    </>)
                },
            },
            {
                Header: t('Survival Period Search Volume'),
                accessor: "survival_period_search_volume",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 260 : 160,
                thClass: 'align-middle text-end',
                description: t('The average daily search volume relative to the average survival period within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '240px' : '140px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
                    </>)
                },
            },
            // {
            //     Header: t('Impression Rate'),
            //     accessor: "impression_rate_sum",
            //     filterable: true,
            //     sortable: true,
            //     thWidth: i18n?.language === 'en' ? 170 : 100,
            //     thClass: 'align-middle text-center',
            //     description: t('The impression rate is the percentage of exposure compared to the daily search volume.'),
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div className="text-center" style={{ minWidth: i18n?.language === 'en' ? '150px' : '80px' }}>{formatNumberWithCommas(cell?.value || 0)} %</div>
            //         </>)
            //     },
            // },
            {
                Header: t('Impression'),
                accessor: "impression",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 130 : 100,
                thClass: 'align-middle text-end',
                description: t('The total exposure within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '110px' : '80px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
                    </>)
                },
            },
            {
                Header: t('Click'),
                accessor: "click",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: i18n?.language === 'en' ? 120 : 100,
                description: t('The total clicks within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '100px' : '80px' }}>{formatNumberWithCommas(cell?.value)}</div>
                        </>
                    )
                },
            },
            {
                Header: t('CTR'),
                accessor: "ctr",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: i18n?.language === 'en' ? 120 : 100,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '100px' : '80px' }}>{formatNumberWithCommas(cell?.value)} %</div>
                        </>
                    )
                },
            },
            {
                Header: t('Article Rank'),
                accessor: "article_rank",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 160 : 110,
                thClass: 'align-middle text-end',
                description: t('The highest article rank within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '140px' : '90px' }}>{cell?.value === null ? '-' : formatNumberWithCommas(cell?.value || 0)}</div>
                    </>)
                },
            },
            {
                Header: t('PA Media Ranking'),
                accessor: "affiliate_rank",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                description: t('The ranking of Press AI-affiliated media in Naver News search results. (Based on today’s data.)'),
                thWidth: i18n?.language === 'en' ? 180 : 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info">
                        {cell?.value ?? '-'}
                    </div>)
                },
            },
            {
                Header: t('PA Media'),
                accessor: "affiliate_media",
                filterable: true,
                sortable: false,
                thClass: 'align-middle text-end',
                thWidth: i18n?.language === 'en' ? 150 : 120,
                description: t("Press AI-affiliated media."),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-3">
                        {cell?.value || '-'}
                    </div>)
                },
            },
            {
                Header: t('News Section'),
                accessor: "news_section_rank",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                description: t('The ranking of the news section in Naver search results for the keyword.'),
                thWidth: i18n?.language === 'en' ? 150 : 130,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '110px' }} className="text-end pe-info">
                        {item?.news_section_rank || '-'}
                    </div>)
                },
            },
            {
                Header: t('Survival Period'),
                accessor: "survival_period",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 170 : 110,
                thClass: 'align-middle text-end',
                description: t('The longest survival period within the specified period.'),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '150px' : '90px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
                    </>)
                },
            },
        ],
        [i18n?.language, userPermissions, JSON.stringify(optionsSelected), query?.published_at_start, query?.published_at_end]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...{ sort_by: sortBy?.sort_by, order_by: sortBy?.order_by } });
        });
    }, []);

    const handleChangeDatePublishedRangePicker = (values: any[] = []) => {
        setDatePublishedRangeSearch((_prev: any) => values);
    }

    const handleChangeDateRangePicker = (values: any[] = []) => {
        setDateRangeSearch((_prev: any) => values);
    }

    const handelChangeCategory = (category_id_search: string) => {
        setOptionsSelected((prev: any) => []);
        const queryNew = {
            ...query,
            category_id: category_id_search,
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                setIsCallAllOptionLoading((_prev) => true);
                const [res1]: any = await Promise.all([getAllCategory()]);
                setIsCallAllOptionLoading((_prev) => false);
                setListCategory((_prev) => res1?.data);
            } catch (error: any) {
                setIsCallAllOptionLoading((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, []);

    useEffect(() => {
        document.title = `${t('Keyword Statistics (Published)')} | ${t('PRESS Ai')}`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Keyword Statistics (Published)')} pageTitle={t('Statistics')} />
                    {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_PUBLISHED_STATISTICS, userPermissions) && (
                        <Row>
                            <Col sm={12} md={12}>
                                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                                    <div className="ribbon round-shape" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem', top: '11px' }}>{t('This data is analyzed per 10 mins')}</div>
                                    <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                                        <Row className="g-4 align-items-center">
                                            <div className="col-sm">
                                                <div>
                                                    <h5 className="card-title mb-0">
                                                        <span className="me-2">{t('Total')}:</span>
                                                        {(isKeywordPublishedLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                            start={0}
                                                            end={keywordPublished?.pagination?.total || 0}
                                                            duration={1}
                                                            className="text-primary"
                                                        />)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Row>
                                    </CardHeader>
                                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                                        <NestingFilter>
                                            <Row className="g-4 align-items-center mt-0">
                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-md-2' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startApprovedArticleSearch}
                                                        valueTo={endApprovedArticleSearch}
                                                        placeholderFrom={`${t('Approved Articles (Start)')}...`}
                                                        placeholderTo={`${t('Approved Articles (End)')}...`}
                                                        labelFrom={`${t('Approved Articles (Start)')}`}
                                                        labelTo={`${t('Approved Articles (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartApprovedArticleSearch(val)}
                                                        onChangeTo={(val) => setEndApprovedArticleSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-md-2' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startDailySearchVolumeSearch}
                                                        valueTo={endDailySearchVolumeSearch}
                                                        placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                                                        placeholderTo={`${t('Daily Search Volume (End)')}...`}
                                                        labelFrom={`${t('Daily Search Volume (Start)')}`}
                                                        labelTo={`${t('Daily Search Volume (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartDailySearchVolumeSearch(val)}
                                                        onChangeTo={(val) => setEndDailySearchVolumeSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-md-2' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startAvgSurvivalPeriodSearch}
                                                        valueTo={endAvgSurvivalPeriodSearch}
                                                        placeholderFrom={`${t('Survival Period (Start)')}...`}
                                                        placeholderTo={`${t('Survival Period (End)')}...`}
                                                        labelFrom={`${t('Survival Period (Start)')}`}
                                                        labelTo={`${t('Survival Period (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartAvgSurvivalPeriodSearch(val)}
                                                        onChangeTo={(val) => setEndAvgSurvivalPeriodSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startImpressionSearch}
                                                        valueTo={endImpressionSearch}
                                                        placeholderFrom={`${t('Impression (Start)')}...`}
                                                        placeholderTo={`${t('Impression (End)')}...`}
                                                        labelFrom={`${t('Impression (Start)')}`}
                                                        labelTo={`${t('Impression (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartImpressionSearch(val)}
                                                        onChangeTo={(val) => setEndImpressionSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startClickSearch}
                                                        valueTo={endClickSearch}
                                                        placeholderFrom={`${t('Click (Start)')}...`}
                                                        placeholderTo={`${t('Click (End)')}...`}
                                                        labelFrom={`${t('Click (Start)')}`}
                                                        labelTo={`${t('Click (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartClickSearch(val)}
                                                        onChangeTo={(val) => setEndClickSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startCtrSearch}
                                                        valueTo={endCtrSearch}
                                                        placeholderFrom={`${t('CTR (Start)')}...`}
                                                        placeholderTo={`${t('CTR (End)')}...`}
                                                        labelFrom={`${t('CTR (Start)')}`}
                                                        labelTo={`${t('CTR (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartCtrSearch(val)}
                                                        onChangeTo={(val) => setEndCtrSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startAvgArticleRankSearch}
                                                        valueTo={endAvgArticleRankSearch}
                                                        placeholderFrom={`${t('Article Rank (Start)')}...`}
                                                        placeholderTo={`${t('Article Rank (End)')}...`}
                                                        labelFrom={`${t('Article Rank (Start)')}`}
                                                        labelTo={`${t('Article Rank (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartAvgArticleRankSearch(val)}
                                                        onChangeTo={(val) => setEndAvgArticleRankSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startAffiliateRankSearch}
                                                        valueTo={endAffiliateRankSearch}
                                                        placeholderFrom={`${t('PA Media Ranking (Start)')}...`}
                                                        placeholderTo={`${t('PA Media Ranking (End)')}...`}
                                                        labelFrom={`${t('PA Media Ranking (Start)')}`}
                                                        labelTo={`${t('PA Media Ranking (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartAffiliateRankSearch(val)}
                                                        onChangeTo={(val) => setEndAffiliateRankSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3' >
                                                    <InputsRange
                                                        nameFrom="from"
                                                        nameTo="to"
                                                        valueFrom={startNewsSectionSearch}
                                                        valueTo={endNewsSectionSearch}
                                                        placeholderFrom={`${t('News Section (Start)')}...`}
                                                        placeholderTo={`${t('News Section (End)')}...`}
                                                        labelFrom={`${t('News Section (Start)')}`}
                                                        labelTo={`${t('News Section (End)')}`}
                                                        isTypeNumber={true}
                                                        onChangeFrom={(val) => setStartNewsSectionSearch(val)}
                                                        onChangeTo={(val) => setEndNewsSectionSearch(val)}
                                                        onKeyDownFrom={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                        onKeyDownTo={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </Col>

                                                <Col sm={6} md={6} xl={6} xxl={2} className='order-3 order-xxl-0 mt-3'>
                                                    <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                                        <Input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder={`${t('Keyword')}...`}
                                                            value={keywordSearch}
                                                            onChange={(e) => setKeywordSearch(e.target.value)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") {
                                                                    searchData();
                                                                }
                                                            }}
                                                        />
                                                    </LabelWrapper>
                                                </Col>

                                                <Col sm={6} md={6} xl={6} xxl={2} className='order-4 order-xxl-0 mt-3'>
                                                    <LabelWrapper label={t('Type')} isShow={true}>
                                                        <DropdownOption
                                                            name="is_golden"
                                                            dataList={TYPE_LEVEL_KEYWORD_OPTIONS_LANG || []}
                                                            placeholder={`${t("Type")}...`}
                                                            className="dropdown-status-rounded z-hight"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={typeKeywordSearch || null}
                                                            onChangeSelect={(e: any) => setTypeKeywordSearch(e)}
                                                            isHasOptionAll={true}
                                                            optionAll={{ label: t('All'), value: '' }}
                                                        />
                                                    </LabelWrapper>
                                                </Col>
                                                <Col sm={6} md={6} xl={6} xxl={2} className='order-1 order-xxl-0 mt-3'>
                                                    <LabelWrapper label={t('PA Media')} isShow={true}>
                                                        <DropdownOption
                                                            name="is_affiliate_rank"
                                                            dataList={AFFILIATE_MEDIA_OPTIONS_LANG || []}
                                                            placeholder={`${t("PA Media")}...`}
                                                            className="dropdown-status-rounded z-hight"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={affiliateMediaSearch || null}
                                                            onChangeSelect={(e: any) => setAffiliateMediaSearch(e)}
                                                            isHasOptionAll={true}
                                                            optionAll={{ label: t('All'), value: '' }}
                                                        />
                                                    </LabelWrapper>
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 date-picker-wrapper-custom mt-3'>
                                                    <LabelWrapper label={t('Published At')} isShow={!!startDatePublished || !!endDatePublished}>
                                                        <DatePickerCustom
                                                            placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                            startDate={startDatePublished || null}
                                                            endDate={endDatePublished || null}
                                                            onChangePicker={handleChangeDatePublishedRangePicker}
                                                            showOptions={[
                                                                'today', 'yesterday', 'two_day_ago',
                                                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                                'this_week', 'last_week',
                                                                'this_month', 'last_month',
                                                            ]}
                                                        />
                                                    </LabelWrapper>
                                                </Col>

                                                <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-2 order-xxl-0 date-picker-wrapper-custom mt-3'>
                                                    <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                                        <DatePickerCustom
                                                            placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                            startDate={startDate || null}
                                                            endDate={endDate || null}
                                                            onChangePicker={handleChangeDateRangePicker}
                                                            showOptions={[
                                                                'today', 'yesterday', 'two_day_ago',
                                                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                                'this_week', 'last_week',
                                                                'this_month', 'last_month',
                                                            ]}
                                                        />
                                                    </LabelWrapper>
                                                </Col>

                                                <Col sm={12} md={12} xl={12} xxl={12} className="order-5 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-end mt-3">
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary me-2 "
                                                            onClick={searchData}
                                                            disabled={(isKeywordPublishedLoading || isCallAllOptionLoading)}
                                                        >
                                                            {(isKeywordPublishedLoading || isCallAllOptionLoading) ? <div className="me-1" style={{ display: 'inline-table', verticalAlign: 'top' }}><Spinner size="sm" style={{ width: '14px', height: '14px' }}></Spinner></div> : <i className="ri-search-line align-bottom me-1"></i>}{" "}
                                                            {t('Button Search')}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary fs-14"
                                                            onClick={resetData}
                                                        >
                                                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                            {t('Button Reset')}
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </NestingFilter>
                                    </div>
                                    <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                                        <Col sm={12} md={12} xl={12} xxl={12} className="mb-3 mb-lg-4">
                                            <div>
                                                <div className="d-flex gap-2 flex-wrap">
                                                    <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === '' ? 'bg-primary text-white' : 'border-gray text-secondary'}`}
                                                        onClick={(e) => { e.preventDefault(); handelChangeCategory('') }}
                                                    >
                                                        {t('All')}
                                                    </button>
                                                    {listCategory?.map((item) => (
                                                        <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === String(item?.id) ? `bg-primary text-white` : `border-gray text-secondary`}`} key={item?.id}
                                                            onClick={(e) => { e.preventDefault(); handelChangeCategory(`${item?.id}`) }}
                                                        >
                                                            {item?.name}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm={12} md={12} xl={12} className="my-0 mt-2 mt-md-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                                            <div>
                                                {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_GOLDEN_UPDATE, userPermissions) &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-warning"
                                                        style={{ width: '165px' }}
                                                        disabled={countRowSelected <= 0}
                                                        onClick={(e) => { e.stopPropagation(); handleConfirmSetGoldenKeyword(null) }}
                                                    >
                                                        {countRowSelected > 0 && (
                                                            <span
                                                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                                                style={{ transform: "translate(0%, -70%)" }}
                                                            >
                                                                {formatNumberWithCommas(countRowSelected)}
                                                                <span className="visually-hidden">
                                                                    total keywords selected
                                                                </span>
                                                            </span>
                                                        )}
                                                        {t('Button Set Golden Keyword')}
                                                    </button>
                                                }
                                            </div>
                                        </Col>
                                    </div>
                                    <CardBody className="pt-3">
                                        <TableContainer
                                            className="custom-header-css"
                                            divClass="table-responsive table-card"
                                            tableClass="align-middle table-bordered-dashed sticky-table-keyword-publish-statistic" // table-have-first-row-is-total
                                            theadClass="table-light text-muted"
                                            columns={columns}
                                            data={keywordPublished?.list?.length ? (
                                                [
                                                    // {
                                                    //     ...keywordPublished?.total,
                                                    //     text_row: t('Sum')
                                                    // },
                                                    ...keywordPublished?.list]
                                            ) : []}
                                            customPageSize={query.limit}
                                            customPageIndex={query.page - 1}
                                            totalRecords={keywordPublished?.pagination?.total}
                                            customPageCount={Math.ceil(Number(keywordPublished?.pagination?.total) / Number(keywordPublished?.pagination?.limit))}
                                            handleChangePage={handleChangePage}
                                            manualSorting={true}
                                            sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                            handleChangeSorting={handleChangeSorting}
                                            isLoading={isKeywordPublishedLoading}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    <ModalConfirm
                        isShowIcon={false}
                        classIconButtonConfirm=''
                        classButtonConfirm={'btn-soft-warning'}
                        header={t('Button Set Golden Keyword')}
                        textButtonConfirm={t('Button Set Golden Keyword')}
                        title={t("Are you sure you want to set Golden Keyword?")}
                        content={t("After confirming the set action, the data will be set. Do you want to proceed with the set action.")}
                        isOpen={isOpenConfirm}
                        isLoading={isConfirmLoading}
                        onClose={onCloseConfirmClick}
                        onConfirm={handleActionSetGoldenKeyword}
                    />
                    {/* <Modal
                        isOpen={!!isOpenNewsTracking}
                        centered={true}
                        size="xl"
                        className={`modal-fullscreen`}
                        scrollable={false}
                        toggle={onClosePageTrackingNewsClick}
                        keyboard={true}
                    >
                        <ModalHeader className="py-3" style={{ borderBottom: '1px solid var(--vz-modal-footer-border-color)' }} toggle={onClosePageTrackingNewsClick}>
                            {t('News Monitor')}
                        </ModalHeader>
                        <ModalBody className="p-0 overflow-x-hidden">
                            <TrackingNewsList isPage={false} />
                        </ModalBody>
                        <ModalFooter className="pt-2 pb-3" style={{ borderTop: '1px solid var(--vz-modal-footer-border-color)' }}>
                            <button
                                type="button"
                                className="btn btn-soft-secondary"
                                disabled={countRowSelected <= 0}
                                onClick={(e) => onClosePageTrackingNewsClick()}
                            >
                                {t('Button Close')}
                            </button>
                        </ModalFooter>
                    </Modal> */}
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default KeywordStatistic;
